/** @jsxImportSource @emotion/react */
import { ReactNode } from 'react';
import { ThemeProvider } from '../ThemeProvider/ThemeProvider';

export const DesignSystemProvider = ({ children }: { children: ReactNode }) => {
  return (
    <ThemeProvider>
      <>
        {children}
        <div id="modal-root" />
      </>
    </ThemeProvider>
  );
};
